import { BrowserRouter } from 'react-router-dom';
import AppRoutes from "./routes/routes";
import './styles/App.scss';
import store from './store/store';
import { Provider } from 'react-redux';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from 'react';
import { LanguageProvider } from './context/LanguageContext';




function App() {

    useEffect(() => {
        const metaViewport = document.querySelector(
            'meta[name="viewport"]'
        );

        if (!metaViewport) return;

        const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(
            navigator.userAgent
        );

        if (isMobile) {
            metaViewport.setAttribute(
            'content',
            'width=device-width,initial-scale=1,maximum-scale=5,user-scalable=1'
            );
        }
    }, []);

    return (

        <div className="App">
             <LanguageProvider>
            <Provider store={store}>
                <BrowserRouter>
                    <ToastContainer position={toast.POSITION.TOP_RIGHT} autoClose={5000} icon={false} />
                    <AppRoutes />
                </BrowserRouter>
            </Provider>
             </LanguageProvider>
        </div>

    );
}

export default App;
